import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { StatusFilterIcon } from '../../../../../assets';
import OptionsSelector, { OptionItem } from '../../../../../components/OptionsSelector/OptionsSelector';
import { useFilterContext } from '../../../../../contexts/FiltersContext';
import { VehicleStatus } from '../../../../../types/api.graphql';
import FilterIconButton from '../shared/FilterIconButton';

const StatusesFilter = () => {
  const { t } = useTranslation();
  const { vehicleStatuses, setVehicleStatuses, getStatusesFiltersCount } = useFilterContext();
  const [statusesCount, setStatusesCount] = useState<OptionItem<VehicleStatus>[]>([]);
  const [isStatusesCountLoading, setIsStatusesCountLoading] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  const getStatusesCount = async () => {
    setIsStatusesCountLoading(true);
    try {
      const response = await getStatusesFiltersCount();
      if (response) {
        return setStatusesCount(
          response.map((status) => ({
            label: t(`listings.status.${status.key}`),
            selected: vehicleStatuses?.includes(status.key as VehicleStatus) || false,
            value: status.key as VehicleStatus,
            data: status.count,
          })),
        );
      }
      return setStatusesCount([]);
    } catch {
      setStatusesCount([]);
    } finally {
      setIsStatusesCountLoading(false);
    }
  };

  useEffect(() => {
    if (!isInitialized) {
      void getStatusesCount();
      setIsInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnOptionsChange = (values: VehicleStatus[]) => {
    setVehicleStatuses(values);
    setStatusesCount(
      (prev) =>
        prev?.map((status) => ({
          ...status,
          selected: values.includes(status.value),
        })) || [],
    );
  };

  return (
    <OptionsSelector
      title={t('listings.statuses')}
      mobileTitle={t('listings.listingsStatus')}
      submitButtonTitle={t('filters.applyFilter')}
      options={statusesCount}
      loadingOptions={isStatusesCountLoading}
      showSelectedCount
      getMobileTriggerComponent={(onClick) => (
        <FilterIconButton onClick={onClick} icon={<StatusFilterIcon />} count={vehicleStatuses?.length} />
      )}
      onOptionsChange={handleOnOptionsChange}
      onOpen={() => void getStatusesCount()}
    />
  );
};

export default StatusesFilter;
